import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  inject
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { from } from 'rxjs';
import { File as FileModel, License } from 'src/app/classes/models';
import { COIScanType } from 'src/app/interfaces/coi-scan-types';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-coi-upload-modal',
  templateUrl: './coi-upload-modal.component.html',
  styleUrls: ['./coi-upload-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CoiUploadModalComponent implements OnInit {
  @Input() InsuranceAgentName?: string;

  COIFiles: FileModel[] = [];
  scanType: null | COIScanType = null;
  scanTypeOptions: { label: string; value: COIScanType }[] = [
    { label: 'COI Quick Scan', value: 'COIQuickScan' },
    { label: 'COI Deep Scan', value: 'COIDeepScan' }
  ];

  private cdr = inject(ChangeDetectorRef);

  constructor(
    public activeModal: NgbActiveModal,
    private ToastService: ToastService,
    private UtilityService: UtilityService
  ) {}

  ngOnInit(): void {}

  fileUpload({ data, type }: { data: File; type: null | 'No Scan' }) {
    const { name: filename, size: filesize, type: filetype } = data;

    const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png'];
    const fileExtension = filename
      .toLowerCase()
      .substring(filename.lastIndexOf('.'));

    if (!allowedExtensions.includes(fileExtension)) {
      this.ToastService.addErrorToast(
        'Error',
        'Only .pdf, .jpg, .jpeg, and .png files are allowed.'
      );
      return;
    }

    from(data.arrayBuffer()).subscribe({
      next: (filecontents) => {
        const fileDataString =
          this.UtilityService.convertArrayBufferToBase64EncodedString(
            filecontents
          );

        const FileData: FileModel = {
          filename,
          filesize,
          filetype,
          FileContent: { filecontents: fileDataString }
        };

        this.COIFiles.push(FileData);
        this.cdr.markForCheck();
      },
      error: (error) => {
        this.ToastService.addErrorToast(
          'Error',
          'Failed to process file upload.'
        );
        console.error('File upload error:', error);
      }
    });
  }

  removeFile({ File, index }: { File: FileModel | License; index: number }) {
    this.COIFiles.splice(index, 1);
    this.cdr.markForCheck();
  }

  save() {
    if (this.COIFiles.length === 0) {
      this.ToastService.addErrorToast(
        'Error',
        'Please upload at least one COI file.'
      );
      return;
    }

    if (this.scanType && this.COIFiles.length > 1) {
      this.ToastService.addErrorToast(
        'Error',
        'Please upload only one COI file to be scanned.'
      );
      return;
    }

    this.activeModal.close({
      scanType: this.scanType,
      COIFiles: this.COIFiles
    });
  }

  cancel() {
    this.activeModal.dismiss('cancel');
  }

  onScanCOIChange(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    const selectedValue = selectElement.value;

    this.scanType = selectedValue as COIScanType | null;
  }
}
